import styled from 'styled-components'

export const Container = styled.div`
  padding: 4rem 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
`
